export class MessageQuoteQuery {
  public symbol: string;
  public company: string;
}
